import React from 'react';
import PropTypes from 'prop-types';
import { get, includes, isNull, isEmpty, concat, without } from 'lodash';

export default class ASQCheckbox extends React.PureComponent {
  static propTypes = {
    asq: PropTypes.object.isRequired,
    responseType: PropTypes.object.isRequired,
    answer: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
  }

  onChange = (e) => {
    const data = get(this.props.answer, 'answerHandles', []);
    const result = e.target.checked ? concat(data, e.target.dataset.handle) : without(data, e.target.dataset.handle);
    const answerId = get(this.props.answer, 'id', null);
    if (isEmpty(result)) {
      this.props.onDelete(answerId, {
        asqResponseTypeId: this.props.responseType.id,
        id: answerId });
    } else {
      this.props.onChange(answerId, {
        asqResponseTypeId: this.props.responseType.id,
        answerHandles: result });
    }
  }

  render() {
    const { responseType, answer, disabled } = this.props;
    const checkBoxes = responseType.possibleAnswers.map ( (a, aIdx) => {
      const bActive = !isNull(answer) && includes(answer.answerHandles, a.handle);
      const id = `rc-${responseType.id}-${aIdx}`;
      return (
        <fieldset key={id} className='o-checkbox-answer'>
          <input
            id={id}
            type="checkbox"
            disabled={disabled}
            checked={bActive}
            data-handle={a.handle}
            onChange={this.onChange}
          />
          <label htmlFor={id}>{a.label}</label>
        </fieldset>
      );
    })
    return (
      <div className='u-padding-bottom--small'>
        {checkBoxes}
      </div>
    );
  }
}
